import styled from "styled-components";


export const Container = styled.div`
    max-width: 1200px;
    width: 100%;
    margin: 0 auto; 
    display: flex;
    box-sizing: border-box;
    @media (max-width: 768px) {
        flex-direction: column;
        margin: 20px 0px;
    }
`
export const AboutSection = styled.div`
    width: 100%; 
    margin: 20px auto;
    padding: 0 20px;
    text-align: justify;
    box-sizing: border-box;
    @media (max-width: 768px) { 
        margin: 0px;   
        text-align: justify;
    }
`
export const Imagem = styled.img`
    max-width: 100%;
    display: block;
    height: auto;
`